import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let installed = false;
let sent = 0;

const report = (message, source, stack) => {
  if (sent >= 5) return;
  sent += 1;
  axios.post(`${API}/monitoring/client-error`, {
    message: String(message || 'Unknown error').slice(0, 500),
    source: String(source || '').slice(0, 200),
    stack: String(stack || '').slice(0, 2000),
    url: window.location.pathname,
  }).catch(() => {});
};

export const installClientErrorReporting = () => {
  if (installed) return;
  installed = true;
  window.addEventListener('error', (e) => report(e.message, e.filename, e.error?.stack));
  window.addEventListener('unhandledrejection', (e) => report(e.reason?.message || String(e.reason), 'unhandledrejection', e.reason?.stack));
};

export const reportError = (error, source) => report(error?.message || String(error), source, error?.stack);
